/**
 * The address bar, without the router.
 *
 * Next patches `history.replaceState` to dispatch a router action, and the App
 * Router runs every server action through one FIFO queue: a dispatch while a read
 * is in flight marks that read discarded, and a discarded entry never settles.
 * The native method is reached through the prototype, which the patch does not
 * cover, so a URL that only has to survive a reload costs nothing in flight.
 *
 * Use it where the parameter is read on mount and nowhere else. A page whose
 * render depends on `useSearchParams` needs the router to know, and must not.
 */
export function setAddressBarUrl(url: URL): void {
  // `history.state` written back unchanged: the router keeps its own entry data.
  History.prototype.replaceState.call(window.history, window.history.state, "", url.toString())
}
